import { BarChart3 } from "lucide-react";
import type { Student } from "@/lib/student.schema";
import HighSchoolScores from "./high-school-scores";
import MathPhysicsScores from "./math-physics-scores";

interface StudentScoresProps {
	student: Student;
}

/**
 * Khối điểm cho khoá tuyển 2026: học bạ 3 năm THPT + điểm Toán/Lý.
 *
 * Cố tình KHÔNG có `BonusPriorityScores`: quy chế 2026 bỏ điểm trúng tuyển và
 * điểm từng môn của tổ hợp, và người dùng đã chốt không hiển thị điểm cộng /
 * điểm ưu tiên nữa. Dữ liệu cũng không còn: trên 5.159 sinh viên khoá 26,
 * `DTB_Toan_3Nam`, `Diem_DGNL`, `DiemCong`, `Diem_UT` đều rỗng 0/5159 — hiện
 * chúng chỉ ra một bảng toàn "0" giả.
 *
 * Cũng là nhánh MẶC ĐỊNH cho mọi diện xét tuyển mà `student-details.tsx` không
 * nhận ra. Trước đây nhánh đó là `null`, nên khi 2026 đổi bộ mã diện
 * (`DGNL_HB`, `THPT_HB`, `XTT`, `UTXT` thay cho `DGNL`, `THPT`, `XTT_BoGD`…)
 * thì toàn bộ 5.159 sinh viên không thấy khối điểm nào. Học bạ 3 năm là thứ mọi
 * sinh viên đều có, nên rơi về đây luôn đúng hơn là không hiện gì.
 */
export default function HocBaScores({ student }: StudentScoresProps) {
	return (
		// `min-h-[18rem]`: cột điểm giữ nguyên khoảng trống khi hồ sơ không có điểm
		// nào, thay vì co lại. Không phải chuyện thẩm mỹ — thẻ sinh viên được chụp
		// ảnh và in, nên chiều cao nhảy giữa hồ sơ có điểm và hồ sơ trống làm mỗi
		// ảnh một khổ, và cán bộ đang lướt nhanh sẽ thấy các khối bên cạnh dịch chỗ
		// giữa hai sinh viên liền nhau.
		<div className="lg:col-span-3 print:col-span-3 space-y-3 lg:min-h-[18rem] print:min-h-[18rem]">
			<div className="space-y-2">
				<div id="header-hocba" className="flex items-center gap-2 mb-2">
					<BarChart3 className="h-5 w-5 text-orange-600" />
					<span className="font-semibold text-lg text-orange-800">Điểm học bạ</span>
				</div>

				<HighSchoolScores student={student} />

				<MathPhysicsScores student={student} />
			</div>
		</div>
	);
}
